var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 31.5,
    r: 30.5,
    fill: "white",
    stroke: "#EEEEFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2667 44.2H25.9333C24.3133 44.2 23 42.8456 23 41.175L23.0001 23.025C23.0001 21.3543 24.3134 20 25.9334 20H39.1338C40.7538 20 42.0671 21.3543 42.0671 23.025V29.075M43.5333 41.9313L45 43.4438M28.1338 26.05H36.9338M28.1338 30.5875H36.9338M28.1338 35.125H32.5338M44.2667 38.9063C44.2667 40.9946 42.625 42.6876 40.6 42.6876C38.575 42.6876 36.9333 40.9946 36.9333 38.9063C36.9333 36.818 38.575 35.125 40.6 35.125C42.625 35.125 44.2667 36.818 44.2667 38.9063Z",
    stroke: "#825DFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.8a212473bc7764eeea64088a9d92b33d.svg";
export { ForwardRef as ReactComponent };